import React from 'react';
export default function Logo(_ref) {
  var appProps = _ref.appProps,
    target = _ref.target,
    classNames = _ref.classNames,
    logo = _ref.logo;
  return /*#__PURE__*/React.createElement("div", {
    className: "logo"
  }, /*#__PURE__*/React.createElement("a", {
    style: {
      height: parseFloat(appProps.frontendStyles.general.logoHeight)
    },
    href: appProps.rootPath,
    target: target
  }, /*#__PURE__*/React.createElement("img", {
    src: logo,
    className: classNames,
    alt: appProps.storeName
  })));
}